import { maintenance } from 'models';
import moment from 'moment';
import React from 'react';
import style from './MaintenanceInfo.module.scss';
export interface MaintenanceInfoProps {
  maintenanceInfo: maintenance;
}

export default function MaintenanceInfo({ maintenanceInfo }: MaintenanceInfoProps) {
  const formatDate = (number: number) => {
    let date = moment(moment().add(2, 'days')).valueOf();
    let day = moment(moment()).valueOf();
    if (number >= date) {
      return 1;
    } else if (number >= day && number < date) {
      return 2;
    } else {
      return 3;
    }
  };
  return (
    <>
      <div className={style.title_maintenanceInfo}>
        <span className={style.title_maintenance_info}>Tiêu dề:</span>
        {maintenanceInfo.title}
      </div>
      <div className={style.jobs_maintenanceInfo}>
        <span className={style.title_maintenance_info}>Nội dung bảo trì:</span>
        {maintenanceInfo.jobs.toString()}
      </div>
      <div className={style.assignedTo_maintenanceInfo}>
        <span className={style.title_maintenance_info}>Người phụ trách:</span>
        {maintenanceInfo.assigned_to.toString()}
      </div>
      <div className={style.time_maintenanceInfo}>
        <span className={style.title_maintenance_info}>Thời gian:</span>
        {moment(maintenanceInfo.time).format('YYYY-MM-DD')}
        <span
          style={{
              backgroundColor:
                formatDate(maintenanceInfo.time) === 1
                  ? "#367BF5"
                  : formatDate(maintenanceInfo.time) === 2
                  ? "#DFBE10"
                  : "#C21515",
            marginLeft: '10px',
            height: '25px',
            color: '#fff',
            width: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '5px',
          }}
        >
          {moment(maintenanceInfo.time).fromNow()}
        </span>
      </div>
    </>
  );
}
